import { useDocument } from "hooks/firestore/core/useDocument"
import { getSettingsRef, getShopRef, getUserRef } from "hooks/firestore/getRefs"
import { useUserId } from "hooks/localstate/auth/useUserId"
import { useShopId } from "hooks/localstate/context/useShopId"

export default function useBasicInfos() {
  const userId = useUserId()
  const shopId = useShopId()

  const { document: userDoc, loading: userLoading } = useDocument(getUserRef(userId))
  const { document: shopDoc, loading: shopLoading } = useDocument(getShopRef(shopId))
  const { document: settingsDoc, loading: settingsLoading } = useDocument(getSettingsRef(shopId))

  const loading = userLoading || shopLoading || settingsLoading
  return { loading, user: userDoc, shop: shopDoc, settings: settingsDoc }
}
